import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { createStore } from 'jotai';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import { createSelector } from 'reselect';
import * as tempDashboardActions from '@store/tempDashboard/actions';
import { tempKeysSelector, afterInitializationSelector } from '@store/tempDashboard/selectors';
import { Loading, PageNotFound } from '@components/common';

const selector = createSelector(
  tempKeysSelector,
  afterInitializationSelector,
  (dashboardKeys, afterInitialization) => ({
    dashboardKeys,
    afterInitialization,
  }),
);

/**
 * @description get localStorage
 * @description update localStorage
 */
const TempDashboardHOC = (Wrapper) => {
  class DetailsTempDashboardPage extends React.PureComponent {
    constructor(props) {
      super(props);
      const {
        init,
        afterInitialization,
        initLocalStorage,
        initStore = createStore,
        selectedAIAlertMetric,
        params,
      } = this.props;

      const { id } = params;
      if (!afterInitialization) {
        initLocalStorage();
      } else {
        init(id);
      }
      this.asyncUpdateDashboard = debounce(props.updateDashboard, 300);

      // new store per instance of temp dashboards
      // TODO: needs to be re-written to be like new share with an initStore workflow
      this.atomStore = initStore({
        alertMetric: selectedAIAlertMetric,
      });
    }

    componentDidUpdate(prevProps) {
      const { init, dashboard, afterInitialization } = this.props;

      const tempDashboardId = this.getTempDashboardId();
      const prevId = this.getTempDashboardId(prevProps);

      if (afterInitialization !== prevProps.afterInitialization) {
        init(tempDashboardId);
        /* tslint:disable-next-line */
      }
      if (prevId !== tempDashboardId) {
        init(tempDashboardId);
      } else if (prevId === tempDashboardId && !isEqual(prevProps.dashboard, dashboard)) {
        this.asyncUpdateDashboard(tempDashboardId, dashboard);
      }
    }

    getTempDashboardId = (props = this.props) => {
      const { params } = props;
      return `${get(params, 'id', -1)}`;
    };

    render() {
      const { dashboardKeys, afterInitialization, isFetching, ...rest } = this.props;

      if (!afterInitialization || isFetching) {
        return <Loading />;
      }
      const tempDashboardId = this.getTempDashboardId();
      if (!dashboardKeys.includes(tempDashboardId)) {
        return <PageNotFound />;
      }
      return <Wrapper id={tempDashboardId} {...rest} store={this.atomStore} />;
    }
  }

  return connect(selector, {
    initLocalStorage: tempDashboardActions.init,
    updateDashboard: tempDashboardActions.set,
  })(DetailsTempDashboardPage);
};

export default TempDashboardHOC;
